// Source: https://stackoverflow.com/a/44122804/1397894

import _chunk from 'lodash/chunk';

/**
 * Split an array into n subarrays (or columns).
 *
 * @param  {Array} array Doesn't necessarily have to be flat, but this func only works 1 level deep
 * @param  {Number} numCols The desired number of columns
 * @param  {Boolean} fill Fill array
 * @return {Array}
 */
export default function splitArray<T>(
  array: T[],
  numCols: number,
  fill = false,
): T[][] {
  const maxColLength = Math.ceil(array.length / numCols);
  const nestedArray = _chunk(array, maxColLength);

  const newArray = [];

  for (let i = 0; i < numCols; i += 1) {
    if (fill) {
      newArray[i] = nestedArray[i] ?? [];
    } else if (nestedArray[i] !== undefined) {
      newArray[i] = nestedArray[i];
    }
  }

  return newArray;
}
